import React, { useCallback, useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { TextField, Button, Box, FormControl, Dialog, DialogContent } from '@mui/material';
import { AccessDataContext } from '../../contextProviders/AccessDataContext';
import './Login.scss';
import envirolabLogo from '../../resources/images/ITK_Envirolab-Core-Small.png';
import { OverlayContext } from '../../contextProviders/OverlayContext';

const Login = () => {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const { loginUser } = useContext(AccessDataContext);
  const { setShowLoadingOverlay } = useContext(OverlayContext);
  const [loginErrors, setLoginErrors] = useState<string>(null);
  const [showOldUserPopup, setShowOldUserPopup] = useState<boolean>(false); 

  const submitLogin = useCallback(
    (e) => {
      e.preventDefault();

      setShowLoadingOverlay(true);

      const loginData = {
        Email: email,
        Password: password,
      };

      loginUser(loginData).then((data) => {
        console.log(data);
        if(data === "OldUser"){
          setShowOldUserPopup(true);
        }
        else{
          setLoginErrors(data);
        }
      }).finally(() => { setShowLoadingOverlay(false); });
    },
    [password, email, loginUser, setShowLoadingOverlay]
  );

  return (
    <Box id="loginBox">
      <Box className="imageBox">
        <img alt="Envirolab logo" src={envirolabLogo} />
      </Box>

      <form onSubmit={submitLogin}>
        <FormControl fullWidth>
          <TextField label="Email" name="email" onChange={(item) => setEmail(item.target.value)} fullWidth required />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            label="Password"
            type="password"
            name="password"
            variant="outlined"
            onChange={(item) => setPassword(item.target.value)}
            fullWidth
            required
          />
        </FormControl>

        {loginErrors ? <Box className="errorMessage">{loginErrors}</Box> : null}

        <Box className="submit">
          <Box>
            <Button className="siteBtn" type="submit" variant="outlined" size="large">
              Submit
            </Button>
          </Box>
          <Box>
            <NavLink className="linkForgot" to="/forgot-password">
              Forgot your password?
            </NavLink>
          </Box>
        </Box>
      </form>

      <Box className="links">
        <Box>
          <p>
            Not already a member? <NavLink to="/register">Register Now!</NavLink>
          </p>
        </Box>
      </Box>

      <Dialog open={showOldUserPopup} onClose={() => setShowOldUserPopup(false)}>
        <DialogContent>
          <Box className="existingUser">
            <h2>Existing User</h2>
            <p>Our records show you are an existing user</p>
            <p>Please reset your password via the <br/><NavLink to="/forgot-password">Forgot Password</NavLink> link to login</p>
          </Box>
        </DialogContent>
      </Dialog>

    </Box>
  );
};

export default Login;
